import { Pipe, PipeTransform } from '@angular/core';
import { TabloGroupConfig } from '@ui/tablo-generator/types';

@Pipe({
    name: 'getRightElementValue',
    standalone: false
})
export class GetRightElementValuePipe implements PipeTransform {
  transform<P extends keyof TabloGroupConfig>(
    rules: TabloGroupConfig,
    prop: P,
    index: number,
    row: number,
    suffix = '',
    mapOptions: Record<any, unknown> = {},
  ): unknown {
    const resolveValue = (raw: unknown): unknown => {
      if (raw === undefined) {
        return undefined;
      }
      if (
        (typeof raw === 'string' || typeof raw === 'number') &&
        raw in mapOptions
      ) {
        return mapOptions[raw];
      }
      if (typeof raw === 'boolean') {
        return raw;
      }

      return typeof raw === 'object' ? raw : `${raw}${suffix}`;
    };

    const childOverride = rules.singleChildConfig?.[index]?.[prop as string];
    if (childOverride !== undefined) {
      return resolveValue(childOverride);
    }

    const { childConfigDifferenceRule: rule = 'none' } = rules;
    let key: keyof TabloGroupConfig | string;

    switch (rule) {
      case 'oddEven':
        key = `${prop}${index % 2 === 0 ? 'Even' : 'Odd'}`;
        break;
      case 'oddEvenRow':
        key = `${prop}${row % 2 === 0 ? 'Even' : 'Odd'}`;
        break;
      case 'none':
      default:
        key = prop as string;
    }

    return resolveValue(rules[key]);
  }
}
